import { render, staticRenderFns } from "./Signing.vue?vue&type=template&id=ff889c2a&scoped=true&"
import script from "./Signing.vue?vue&type=script&lang=js&"
export * from "./Signing.vue?vue&type=script&lang=js&"
import style0 from "./Signing.vue?vue&type=style&index=0&id=ff889c2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff889c2a",
  null
  
)

export default component.exports